(() => {
    angular
        .module('app.settings')
        .controller('BasicInfoSettingsController', BasicInfoSettings);


    BasicInfoSettings.$inject = ['$scope', 'SettingsService', 'AccountData'];

    function BasicInfoSettings($scope, SettingsService, AccountData) {
        // because of route configuration, Account Data is already resolved by the time this is called
        var vm = this;

        vm.apiSettings = {
            credentials: [],
            showSecret: function (credentialsIndex) {
                this.credentials[credentialsIndex].shownSecret = this.credentials[credentialsIndex].realSecret;
            }
        };

        vm.companyName = SettingsService.getCompanyName();
        vm.CID = SettingsService.getCID();

        if (AccountData.companyApiKeys) {
            for (var k in AccountData.companyApiKeys) {
                vm.apiSettings.credentials.push({
                    key: AccountData.companyApiKeys[k].key,
                    realSecret: AccountData.companyApiKeys[k].secret,
                    shownSecret: null
                });
            }
        }

        $scope.$watch(function () {
            return vm.companyName;
        }, function (newValue, oldValue) {
            if (newValue && (newValue != oldValue)) {
                SettingsService.setCompanyName(newValue);
            }
        });
    }
})();
